<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">Waiting for Yesterday</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#one">One</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#two">Two</a>
</li>
<li id="toc-li-3">
<span href="#/text/ch003#three" title="Link target outside of Sample">Three</span>
</li>
<li id="toc-li-4">
<span href="#/text/ch004#four" title="Link target outside of Sample">Four</span>
</li>
<li id="toc-li-5">
<span href="#/text/ch005#five" title="Link target outside of Sample">Five</span>
</li>
<li id="toc-li-6">
<span href="#/text/ch006#six" title="Link target outside of Sample">Six</span>
</li>
<li id="toc-li-7">
<span href="#/text/ch007#seven" title="Link target outside of Sample">Seven</span>
</li>
<li id="toc-li-8">
<span href="#/text/ch008#eight" title="Link target outside of Sample">Eight</span>
</li>
<li id="toc-li-9">
<span href="#/text/ch009#nine" title="Link target outside of Sample">Nine</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch010#ten" title="Link target outside of Sample">Ten</span>
</li>
<li id="toc-li-11">
<span href="#/text/ch011#eleven" title="Link target outside of Sample">Eleven</span>
</li>
<li id="toc-li-12">
<span href="#/text/ch012#twelve" title="Link target outside of Sample">Twelve</span>
</li>
<li id="toc-li-13">
<span href="#/text/ch013#next-in-series" title="Link target outside of Sample">Next in Series</span>
</li>
<li class="author_bio">
<span href="#/text/author_bio" title="Link target outside of Sample">About the Author</span>
</li>
<li class="also_by">
<span href="#/text/also_by" title="Link target outside of Sample">Also by Grace Thompson</span>
</li>
<li id="toc-li-14">
<span href="#/text/ch014#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?21067790